<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺</el-breadcrumb-item>
        <el-breadcrumb-item>必填项</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col>
      <el-row>
        <el-col class="block">
          <el-row>
             <el-col :span="24">
              <el-steps :active="active">
                <el-step title="选择标签组" description="请首先选择标签组"></el-step>
                <el-step title="选择标签" description="请选择标签"></el-step>
                <el-step title="编辑标签" description="请点击+号编辑标签值"></el-step>
              </el-steps>
            </el-col>
            <el-col :span="24">
              <el-breadcrumb separator-class="el-icon-arrow-right" class="curreditor">
                <el-breadcrumb-item><i class="el-icon-menu"></i>当前编辑</el-breadcrumb-item>
                <el-breadcrumb-item>
                  <span v-if="currtg.showName">{{ currtg.showName }}</span>
                  <span v-else>未选择标签组</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                  <span v-if="currat.showName" style="color: red; font-weight: bolder">{{ currat.showName }}</span>
                  <span v-else>未选择标签</span>
                </el-breadcrumb-item>
              </el-breadcrumb>
            </el-col>
            <el-col :span="8" class="atgroup">
              <div class="optiontitle"><i class="fa fa-tags"></i>标签组</div>
              <span class="tagsbox" v-for="tg in attrigroup" :key="tg.ID">
                <el-tag size="medium" @click="gpclick(tg)" class="tagtarget" type="success">{{ tg.showName }}</el-tag>
              </span>
            </el-col>
            <el-col :span="8" class="atgroup">
              <div class="optiontitle"><i class="fa fa-tag"></i>标签</div>
              <span class="tagsbox"  v-if="attribute.length === 0">当前未选择标签组或则标签组未配置标签</span>
              <span class="tagsbox" v-else v-for="tg in attribute" :key="tg.ID">
                <el-tag @click="atclick(tg)" size="medium"  class="tagtarget" type="success">{{ tg.showName }}</el-tag>
              </span>
            </el-col>
            <el-col :span="8" class="atgroup">
              <div class="optiontitle"><i class="fa fa-wpexplorer"></i>标签值</div>
              <span class="tagsbox" v-for="tg in vlist" :key="tg.ID">
               <el-tag size="medium" @click="vlclick(tg)" closable @close="handleValueClose(tg.ID)"  class="tagtarget" type="success">{{ tg.field }}</el-tag>
              </span>
              <el-button class="button-new-attribute-value" size="small" @click="showInput">+ 新增标签值</el-button>
              <el-dialog :visible.sync="addattriDialogVisible" :before-close="handleClose" width="30%">
                <span>
                    <el-form name="addForm" :model="vlAddData" ref="addForm" :rules="addrules" validate-on-rule-change="true" label-width="100px" class="addForm">
                      <el-form-item label="系统名称" prop="field">
                        <el-input v-model="vlAddData.field" placeholder="请输入系统名称"></el-input>
                      </el-form-item>
                      <el-form-item label="店铺名称" prop="value">
                        <el-input v-model="vlAddData.value" placeholder="请输入店铺名称"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button @click="addattriDialogVisible = false">取 消</el-button>
                        <el-button type="danger" @click="applyattributevalue('addForm')">确 定</el-button>
                      </el-form-item>
                    </el-form>
                  </span>
              </el-dialog>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'OptionAttribute',
  data () {
    return {
      attrigroup: [],
      active: 0,
      attribute: [],
      currtg: {},
      currat: {},
      vlist: [],
      addattriDialogVisible: false,
      vlAddData: {},
      addrules: {
        field: [{ required: true, message: '系统名称不能为空', trigger: 'blur' }],
        value: [{ required: true, message: '店铺名称不能为空', trigger: 'blur' }]
      },
      clickTagValue: {}
    }
  },
  mounted: function () {
    this.loadAttriGroup()
  },
  methods: {
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    loadAttriGroup: function () {
      var that = this
      var params = {
        method: 'shop.tagsgroup'
      }
      this.$http.post(that.$apiurl, params).then(function (ret) {
        that.attrigroup = ret.body.data
      })
    },
    gpclick (gid) {
      this.active = 1
      this.currtg = gid
      this.currat = {}
      var that = this
      var data = {
        gid: gid.ID,
        method: 'shop.tgtags'
      }
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.attribute = ret.body.data
      })
    },
    atclick (tid) {
      this.active = 2
      this.currat = tid
      var that = this
      var data = {
        tid: tid.ID,
        method: 'shop.tagsvalue'
      }
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.vlist = ret.body.data
      })
    },
    vlclick (vid) {
      this.active = 3
      this.clickTagValue = vid
    },
    showInput: function () {
      if (this.currat.showName) {
        this.addattriDialogVisible = true
      } else {
        this.$alert('请先确认编辑标签')
      }
    },
    loadValueList (tid) {
      var that = this
      var data = {
        tid: tid,
        method: 'shop.tagsvalue'
      }
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.vlist = ret.body.data
      })
    },
    applyattributevalue (e) {
      var that = this
      that.$refs[e].validate(valid => {
        var params = that.vlAddData
        params['method'] = 'base.addattrivalue'
        params['tid'] = that.currat.ID
        var tid = that.currat.ID
        this.$http.post(that.$apiurl, params).then(function (ret) {
          if (ret.body.data.code === 200) {
            that.$message.success('新属性值申请成功！')
            that.loadValueList(tid)
            that.addattriDialogVisible = false
          } else {
            this.$alert('新属性值申请失败，请稍后重试!')
          }
        })
      })
    },
    handleValueClose (vid) {
      var params = {
        vid: vid,
        method: 'base.removeattrivalue'
      }
      var that = this
      this.$http.post(that.$apiurl, params).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('属性值删除成功！')
          console.log(that.clickTagValue)
          that.loadValueList(that.currat.ID)
        } else {
          this.$alert('属性值删除失败，请稍后重试!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shop/OptionAttribute.vue